<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderSlotsTracker } from '../../model/shift-control/header-slots-tracker.hook'
import ButtonTrackerRefresh from './ButtonTrackerRefresh.vue'

defineOptions({
  name: 'HeaderSlotsTracker',
})

const {
  config,
} = useHeaderSlotsTracker()
</script>

<template>
  <div class="box-tracker">
    <NavigationBreadcrumbs
      :config="config"
    />
    <ButtonTrackerRefresh />
  </div>
</template>

<style scoped lang="scss" src="./HeaderSlotsTracker.scss" />
